// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ia_Bb","select":"styles_select__gMk0v"};